import React from "react";
import styles from "../styles";

const TermsAndCondition = () => {
  return (
    <React.Fragment>
      <span className="root">
        <span className="header">
          CONTRATO DE LICENCIA DE USUARIO FINAL (CLUF) DE SOFTWARE TREND
          AnyWARE®
        </span>

        <span className="lineBreak">
          AL HACER CLIC EN EL BOTÓN “ACEPTAR” QUE APARECE A CONTINUACIÓN, ACEPTA
          LOS TÉRMINOS DE ESTE CLUF QUE LE VINCULARÁN
        </span>

        <span className="lineBreak">
          Este contrato de licencia de usuario final, de la forma en que sea
          modificado oportunamente por nosotros de acuerdo con la sección 12 (
          <b>CLUF</b>), es un acuerdo legalmente vinculante entre usted (una
          persona o una sola entidad) e TREND Networks Limited (<b>TREND</b>)
          para el acceso y uso del software TREND AnyWARE® que acompaña a este
          CLUF, y puede incluir medios asociados, materiales impresos,
          documentación electrónica o en línea y servicios basados en Internet (
          <b>Software</b>). El software le permite interactuar con los datos y
          acceder a ellos desde el equipo de prueba, dispositivos y herramientas
          de TREND compatibles (<b>Herramientas</b>). Se puede acceder al
          Software mediante un navegador web en cualquier dispositivo o
          descargarse e instalarse en un ordenador.
        </span>

        <span className="lineBreak">
          <b>IMPORTANTE: LEA DETENIDAMENTE LOS TÉRMINOS DE ESTE CLUF.</b>
          CONTIENE TÉRMINOS IMPORTANTES QUE LE AFECTAN A USTED Y A SU USO DEL
          SOFTWARE, Y DEBE SER EVALUADO POR USTED CON LA VERSIÓN ACTUAL DEL CLUF
          COMO Y CUANDO SE IMPLEMENTE. AL CREAR UNA CUENTA, INSTALAR O ACCEDER
          DE CUALQUIER OTRO MODO O USAR EL SOFTWARE O CUALQUIER PARTE DEL MISMO,
          USTED ACEPTA QUE HA LEÍDO, ENTENDIDO Y ACEPTADO QUEDAR OBLIGADO POR
          LOS TÉRMINOS DE ESTE CLUF EN SU PROPIO NOMBRE Y, SEGÚN CORRESPONDA, EN
          NOMBRE DE LA EMPRESA O ENTIDAD QUE LE EMPLEA O QUE REPRESENTA. SI NO
          ESTÁ DE ACUERDO, NO ACCEDA, INSTALE, COPIE NI UTILICE EL SOFTWARE Y,
          EN CASO DE QUE NO ACEPTE NINGUNA ENMIENDA A ESTE CLUF, YA NO TENDRÁ
          DERECHO O LICENCIA PARA ACCEDER O UTILIZAR EL SOFTWARE, Y DEBERÁ
          DESINSTALAR O DEJAR DE ACCEDER O UTILIZAR EL SOFTWARE DE INMEDIATO.
        </span>

        <span className="lineBreak">
          USTED DECLARA Y GARANTIZA QUE ESTÁ SUSCRIBIENDO ESTE CLUF EN EL
          TRANSCURSO DE SU ACTIVIDAD COMERCIAL O CON FINES COMERCIALES (Y NO
          COMO CONSUMIDOR). SIN EMBARGO, EN CASO DE QUE CUALQUIER LEY DE CONSUMO
          SE APLIQUE CONFORME A LA LEGISLACIÓN APLICABLE, ESTE CLUF NO AFECTA NI
          PERJUDICA NINGÚN DERECHO DE CONSUMIDOR LEGAL QUE PUEDA TENER CONFORME
          A LA LEGISLACIÓN APLICABLE. SI ESTÁ SUSCRIBIENDO ESTE CLUF EN NOMBRE
          DE UNA EMPRESA U OTRA ENTIDAD LEGAL, USTED DECLARA Y GARANTIZA QUE
          TIENE LA AUTORIDAD PARA VINCULAR A DICHA EMPRESA O ENTIDAD CON LOS
          TÉRMINOS DE ESTE CLUF, EN CUYO CASO LOS TÉRMINOS “USTED” O “SU”
          TAMBIÉN SE REFERIRÁN A LA EMPRESA O ENTIDAD QUE USTED REPRESENTA O DE
          LA QUE ES EMPLEADO, SUS FILIALES Y SUS DIRECTORES, FUNCIONARIOS,
          EMPLEADOS, AGENTES Y REPRESENTANTES.
        </span>

        <ol>
          <li>
            <b>USO DEL SOFTWARE</b>
            <ol>
              <li>
                Con sujeción a su cumplimiento de los términos de este CLUF,
                TREND le otorga un derecho y licencia no exclusivos,
                intransferibles, no sublicenciables, revocables y limitados para
                descargar, instalar, activar, acceder o utilizar de otro modo
                las versiones de código objeto del Software en un dispositivo de
                su propiedad o controlado por usted, exclusivamente para sus
                operaciones internas, según lo permitido por este CLUF.
              </li>
              <li>
                Puede permitir a un tercero o usuarios dentro de su empresa u
                organización (<b>Usuarios permitidos</b>) el derecho a acceder y
                utilizar el Software en el transcurso normal de su trabajo si
                dicho uso es exclusivamente: (i) en su nombre; (ii) para sus
                operaciones internas y (iii) de conformidad con este CLUF. Se
                asegurará de que todos sus Usuarios autorizados aceptan cumplir
                con los términos de este CLUF, han sido notificados y han
                prestado su consentimiento para la recopilación, el uso y la
                divulgación de su información personal por parte de TREND, de
                conformidad con los términos de la Política de privacidad de
                TREND, antes de proporcionar a sus Usuarios autorizados acceso
                al Software. Todas las referencias a “usted” o “su” en este CLUF
                también se interpretarán para referirse a sus Usuarios
                autorizados. Usted es responsable de: (a) identificar y
                autenticar todos los Usuarios autorizados; (b) aprobar el acceso
                de dichos Usuarios autorizados al Software; (c) garantizar el
                cumplimiento de los Usuarios autorizados de este CLUF; (d)
                controlar el acceso no autorizado o el uso por parte de Usuarios
                autorizados; (e) mantener la confidencialidad de los nombres de
                usuario, contraseñas e información de cuenta, y (f) proporcionar
                u obtener las notificaciones o consentimientos necesarios de los
                Usuarios autorizados según lo requiera la legislación aplicable,
                lo que incluye, sin limitación, antes de activar la función de
                seguimiento de ubicación en las Herramientas. TREND no es
                responsable de ningún daño causado por sus Usuarios autorizados,
                incluidas las personas que no estaban autorizadas a tener acceso
                al Software, pero que pudieron acceder a él porque los nombres
                de usuario, l as contraseñas o cuentas no se cancelaron de forma
                oportuna en su infraestructura local de gestión de identidades,
                sus dispositivos locales o de otra forma por usted o en su
                nombre. Usted es responsable de todas las actividades que se
                produzcan en o en relación con su nombre, contraseña y cuenta, o
                los de sus Usuarios autorizados, o como resultado de su acceso o
                el de los Usuarios autorizados al Software, y acepta notificar a
                TREND inmediatamente por escrito cualquier uso no autorizado.
                Usted acepta hacer todo lo posible por evitar que terceros no
                autorizados accedan al Software. Usted será responsable de todos
                los actos y omisiones de cualquier Usuario autorizado, y
                exonerará a TREND frente a todos los costes, gastos,
                reclamaciones, pérdidas o daños incurridos o sufridos por TREND,
                o de los cuales TREND pueda ser responsable (ya sean directos,
                indirectos o emergentes, y que incluyen cualquier pérdida
                económica u otra pérdida de beneficios, negocios o fondo de
                comercio) que surjan de cualquier acto u omisión de cualquier
                Usuario autorizado.
              </li>
              <li>
                Debe designar uno o más Usuarios autorizados como administrador
                (<b>Administrador</b>) de su cuenta. Usted acepta que el
                Administrador, en su nombre, podrá otorgar y revocar los
                derechos de acceso y uso de otros Usuarios autorizados, en
                cualquier momento y por cualquier motivo. Puede cambiar sus
                Administradores en cualquier momento y por cualquier motivo
                actualizando su designación.
              </li>
              <li>
                Usted acepta que es el único responsable de (y que TREND no
                tiene responsabilidad frente a usted ni frente a ningún tercero
                por) su uso del Software, el incumplimiento de sus obligaciones
                en virtud de este CLUF y de las consecuencias (incluida
                cualquier pérdida o daño que pueda sufrir TREND) de tal
                incumplimiento.
              </li>
              <li>
                Puede acceder al Software en sus dispositivos mediante un
                navegador web. Se puede descargar e instalar una versión
                independiente en un PC que funcione con Microsoft Windows. La
                versión independiente permite la comunicación con las
                Herramientas mediante conexión directa, no a través de Internet.
              </li>
              <li>
                Para descargar, instalar, activar, acceder o utilizar de otro
                modo el Software, se le pedirá que se registre para crear una
                cuenta. TREND se reserva el derecho, a su entera y absoluta
                discreción, de rechazar cualquier registro. A cambio de su uso
                del Software, usted se compromete a: (i) proporcionar
                información de cuenta precisa, actual y completa; (ii) mantener
                y actualizar de forma constante la información de su cuenta;
                (iii) mantener la seguridad de su(s) contraseña(s) y aceptar
                todos los riesgos de acceso no autorizado a su cuenta y la
                información que proporcione a TREND, y (iv) notificarnos de
                inmediato si descubre o sospecha de alguna forma cualquier
                violación de seguridad relacionada con el Software o su uso de
                este.
              </li>
              <li>
                Para permitir que TREND lleve a cabo el servicio, mantenimiento
                y soporte del Software, usted deberá otorgar a TREND el acceso
                que este necesite para iniciar sesión en su cuenta y utilizar su
                cuenta como si fuera utilizada por usted. Dicho acceso
                autorizado incluye el derecho de que TREND pueda ver, modificar
                y eliminar sus datos.
              </li>
              <li>
                En la medida permitida por la ley, TREND puede eliminar
                cualquiera de sus datos en la medida en que cualquier acto u
                omisión por parte de usted no cumpla con este CLUF. TREND
                intentará avisarle antes de la eliminación de sus datos, pero no
                infringirá este CLUF si no lo hace. Si descarga sus datos y los
                elimina de nuestros servidores, o de los servidores de un
                tercero, dichos datos descargados y eliminados ya no serán
                accesibles a través del Software o de nuestros servidores, o de
                los servidores de dicho tercero.
              </li>
              <li>
                Usted es el único responsable de proporcionar y mantener a su
                cargo todas las herramientas, equipo, software, servicios y
                otros elementos necesarios para utilizar el Software y las
                Herramientas (incluidos, entre otros, cualquier hardware o
                software de ordenador o dispositivo, módems, servicio telefónico
                y acceso a Internet).
              </li>
              <li>
                Usted reconoce que su uso del Software puede requerir una
                conexión a Internet y que puede incurrir en cargos de datos
                relacionados con la información transmitida (ya sea enviada o
                recibida) por su dispositivo mientras utiliza el Software. Usted
                es el único responsable de dichos cargos de datos.
              </li>
            </ol>
          </li>

          <li>
            <b>RESERVA DE DERECHOS Y PROPIEDAD</b>
            <ol>
              <li>
                El software le es licenciado, no vendido, para su uso solo de
                acuerdo con los términos de este CLUF. El título, propiedad y
                todos los derechos con respecto a: (i) el Software (incluidos,
                entre otros, todos los derechos de propiedad intelectual), y
                (ii) todo el contenido y otros materiales proporcionados por
                TREND o nuestros terceros licenciantes, incluidos, sin
                limitación, los logotipos de TREND e TREND AnyWARE® y todos los
                diseños, textos, gráficos, fotos, información, datos, software,
                archivos de sonido, otros archivos y la selección y disposición
                de los mismos (en conjunto, el Contenido) son propiedad
                exclusiva de TREND o de nuestros licenciantes, según
                corresponda, y están protegidos por derechos de autor y otros
                derechos de propiedad intelectual y leyes aplicables, y seguirán
                siendo propiedad de TREND. TREND se reserva todos los derechos
                que no se le otorguen expresamente a usted en este CLUF, y no se
                otorgan otros derechos, ya sea de forma expresa o implícita.
              </li>
              <li>
                “TREND”, “TREND Networks”, “TREND AnyWARE”, “LanTEK”, “TREND
                Networks”, “FiberTEK”, “SignalTEK”, “NaviTEK”, “SecuriTEST”,
                “LanXPLORER”, “UniPRO MGig1” y los logotipos de TREND Networks e
                TREND AnyWARE® y cualesquiera otros nombres de servicio o
                producto, logotipos o eslóganes de TREND que pueden aparecer en
                el Software o el Contenido son marcas comerciales de TREND, y ni
                estos ni los logotipos de nombre o eslóganes confusamente
                similares pueden copiarse, imitarse o utilizarse, total o
                parcialmente, sin el permiso previo por escrito de TREND. Las
                marcas de terceros que aparecen en el Software o en el Contenido
                son propiedad de terceros y no pueden utilizarse sin el permiso
                del titular de la marca comercial pertinente. No puede utilizar
                metaetiquetas u otro “texto oculto” que contengan “TREND” o
                cualquier otro nombre, marca comercial o nombre de producto o
                servicio de TREND sin nuestro permiso previo por escrito.
                Además, el aspecto y apariencia del Software, incluidos todos
                los encabezados de página, gráficos personalizados, iconos de
                botones y scripts, son la marca de servicio, marca comercial o
                imagen comercial de TREND y no se pueden copiar, imitar o
                utilizar, total o parcialmente, sin nuestro permiso previo por
                escrito. La referencia a cualquier producto, servicio, proceso u
                otra información por nombre, marca comercial, fabricante o de
                otro modo no constituye ni implica el respaldo, patrocinio o
                recomendación del mismo por TREND.
              </li>
            </ol>
          </li>

          <li>
            <b> RESTRICCIONES Y LIMITACIONES </b>
            <ol>
              <li>
                Usted entiende y acepta que solo utilizará el Software de forma
                que cumpla con todas las leyes aplicables en la jurisdicción en
                la que utilice el Software. Si incumple este CLUF, puede estar
                sujeto a acciones judiciales y daños y perjuicios.
              </li>
              <li>
                Usted no podrá, ni permitirá a ningún tercero:
                <ol>
                  <li>
                    descargar, instalar, activar, acceder o utilizar de
                    cualquier otro modo el Software o el Contenido en cualquier
                    dispositivo que no sea de su propiedad o que no controle
                    legalmente;
                  </li>
                  <li>
                    publicar, debatir, divulgar, difundir o diseminar de
                    cualquier otro modo a terceros los resultados de las pruebas
                    obtenidos del uso de las Herramientas;
                  </li>
                  <li>
                    traducir, fusionar, adaptar, variar, alterar o modificar la
                    totalidad o parte del Software, ni permitir que ninguna
                    parte de este se combine con, o se incorpore en, cualquier
                    otro programa;
                  </li>
                  <li>
                    realizar ingeniería inversa, descompilar, intentar derivar
                    el código fuente, modificar o desmontar, en su totalidad o
                    en parte, el Software, excepto solo en la medida en que
                    dicha actividad esté expresamente permitida por la
                    legislación aplicable;
                  </li>
                  <li>
                    eliminar o alterar cualquier aviso o marca de propiedad del
                    Software;
                  </li>
                  <li>
                    crear obras derivadas basadas en la totalidad o parte del
                    Software;
                  </li>
                  <li>
                    copiar o reproducir el Software fuera de su organización;
                  </li>
                  <li>
                    vender, asignar, licenciar, distribuir, alquilar, arrendar,
                    sublicenciar, prestar o proporcionar o poner a disposición
                    el Software, en ninguna forma, total o parcialmente, a
                    cualquier persona sin el consentimiento previo por escrito
                    de TREND;
                  </li>
                  <li>
                    utilizar el Software de forma ilegal, para fines ilegales, o
                    de cualquier forma incoherente con estos términos, o actuar
                    de forma fraudulenta o maliciosa, por ejemplo, mediante
                    pirateo o inserción de código malicioso, como virus, o datos
                    dañinos, en el Software o en cualquier sistema operativo;
                  </li>
                  <li>
                    infringir nuestros derechos de propiedad intelectual o los
                    de cualquier tercero en relación con su uso del Software,
                    incluido el envío de cualquier material (en la medida en que
                    dicho uso no esté autorizado por estos términos);
                  </li>
                  <li>
                    transmitir cualquier material que sea difamatorio, ofensivo
                    u objetable en relación con su uso del Software;
                  </li>
                  <li>
                    utilizar el Software de cualquier modo que pueda dañar,
                    deshabilitar, sobrecargar o perjudicar el Software (o
                    servidores o redes conectados al Software);
                  </li>
                  <li>
                    utilizar el Software de modo que pueda interferir con el uso
                    y disfrute del Software (o servidores o redes conectados al
                    Software) por parte de otra persona;
                  </li>
                  <li>
                    desarrollar aplicaciones de terceros que interactúen con el
                    Software sin el consentimiento previo por escrito de TREND;
                  </li>
                  <li>
                    recopilar información o datos a través de su uso del
                    Software o de los sistemas de TREND, o intentar descifrar
                    cualquier transmisión a o desde los servidores que ejecuten
                    el Software, o
                  </li>
                  <li>
                    utilizar el Software para fines para los que no fue diseñado
                    o concebido, ni para ningún otro propósito que no sea el
                    descrito en el presente documento.
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            <b> RECOGIDA Y USO DE DATOS</b>
            <ol>
              <li>
                Usted acepta que TREND y sus filiales pueden recoger y usar
                información técnica recopilada como parte de los servicios de
                soporte de productos que se le proporcionan, si procede,
                relacionados con el Software. TREND puede utilizar esta
                información únicamente para mejorar nuestros productos o para
                proporcionarle servicios o tecnologías personalizados a usted, y
                no divulgará esta información de forma que le identifique
                personalmente.
              </li>
              <b class="subHeading">Datos personales</b>
              <li>
                Usted reconoce que al descargar, instalar, activar, acceder a o
                utilizar de otro modo el Software, TREND puede utilizar medios
                automáticos (incluidas, por ejemplo, cookies y balizas web) para
                recoger información sobre su dispositivo y sobre su uso del
                Software. Es posible que usted y sus Usuarios autorizados
                también deban proporcionar cierta información personal como
                condición para descargar, instalar, activar, acceder a o
                utilizar el Software o ciertas funciones o funcionalidades.
                Según la legislación de protección de datos, debemos
                proporcionarle cierta información sobre quiénes somos, cómo
                tratamos sus datos personales y con qué fines, y sus derechos en
                relación con sus datos personales y cómo ejercerlos. Esta
                información se proporciona en la política de privacidad de
                TREND, que se encuentra en
                <a
                  href="https://www.trend-networks.com/UK/EN/Privacy-Policy.aspx"
                  target="_blank"
                >
                  <b>
                    https://www.trend-networks.com/UK/EN/Privacy-Policy.aspx
                  </b>
                </a>
                , que puede actualizarse periódicamente sin previo aviso
                (Política de privacidad), y es importante que la lea. Al
                descargar, instalar, activar, acceder a o utilizar el Software y
                proporcionar información a o a través del Software, usted acepta
                todo uso y acción adoptada por TREND con respecto a su
                información de conformidad con la Política de privacidad.
              </li>
              <li>
                Tenga en cuenta que las transmisiones por Internet nunca son
                completamente privadas o seguras y que cualquier mensaje o
                información que envíe utilizando el Software puede ser leído o
                interceptado por otros, incluso si hay un aviso especial de que
                una transmisión concreta está cifrada.
              </li>
              <b class="subHeading">Datos de usuario final</b>
              <li>
                En relación con el Software, TREND puede recoger y mantener
                datos introducidos o cargados por usted o en su nombre a través
                del Software, lo que incluye, entre otros, información
                relacionada con su uso de las Herramientas y los Usuarios
                autorizados de la misma (<b>Datos de usuario final</b>). Usted
                será el titular de todos los Datos de usuario final y estará de
                acuerdo en que usted es el único responsable de los Datos de
                usuario final. TREND mantendrá de forma confidencial todos los
                aspectos personales identificables de todos los Datos de usuario
                final de conformidad con la Política de privacidad. Todos los
                terceros autorizados por TREND que puedan tener acceso a los
                Datos de usuario final estarán obligados mediante condiciones de
                confidencialidad y deberán cumplir con toda la legislación de
                protección de datos pertinente. Usted acepta y por la presente
                otorga a TREND un derecho y licencia irrevocables, perpetuos,
                sin regalías, transferibles y sublicenciables para usar,
                reproducir, modificar, adaptar, traducir, divulgar,
                comercializar, asignar, transportar, vender, arrendar, licenciar
                o transferir Datos de usuario final, total o parcialmente, en la
                medida en que no contengan datos personales. Al cargar o
                transmitir Datos de usuario final mediante el Software, declara
                y garantiza que: (i) dichos Datos de usuario final no están
                sujetos a obligaciones de confidencialidad de terceros que
                pudieran ser vulneradas por el uso de dichos Datos de usuario
                final de conformidad con los términos de este CLUF; (ii) usted
                posee y controla todos los derechos de los Datos de usuario
                final que crea, carga o transmite o tiene todos los derechos
                necesarios para crear, cargar o transmitir dichos Datos de
                usuario final mediante el Software; (iii) los Datos del usuario
                final son precisos y no engañosos o dañinos de ninguna manera, y
                (iv) los Datos del usuario final, y su uso, carga y transmisión
                de los mismos, no incumple ni incumplirá los términos de este
                CLUF ni ninguna ley, norma o regulación aplicable. Sin perjuicio
                de otros términos de este CLUF, TREND puede en cualquier
                momento: (a) eliminar cualquier Dato de usuario final o (b)
                suspender su cuenta y acceso al Software. Se asegurará de que
                conserva copias de todos los Datos del usuario final cargados,
                transmitidos o enviados a TREND a través del Software, e TREND
                no tendrá responsabilidad alguna por la pérdida de ningún Dato
                de usuario final, ni ninguna pérdida de uso del Software.
              </li>
              <b class="subHeading">Datos de TREND </b>
              <li>
                Toda la información, lo que incluye, entre otros, datos,
                análisis, mediciones, informes, tendencias e indicadores,
                generados desde, derivados de, basados en o relacionados con
                Datos de usuario final (<b>Datos de TREND</b>) es propiedad
                única de TREND. TREND tiene el derecho a usar, recopilar,
                almacenar, crear, agregar, minar, analizar, modificar,
                comercializar, asignar, transportar, vender, arrendar, licenciar
                o transferir datos de TREND de cualquier forma, para cualquier
                propósito y en cualquier formato.
              </li>
            </ol>
          </li>

          <li>
            <b> ACTUALIZACIONES</b>
            <ol>
              <li>
                TREND puede modificar el Software sin previo aviso, incluido,
                entre otros, el cambio de la funcionalidad o apariencia del
                Software.
              </li>
              <li>
                TREND puede ocasionalmente desarrollar y proporcionar
                actualizaciones de Software a su entera discreción, que pueden
                incluir actualizaciones, correcciones de errores, parches y
                otras correcciones de errores o nuevas funciones
                (colectivamente, incluida la documentación relacionada, “
                <b>Actualizaciones</b>”). Las actualizaciones también pueden
                modificar o eliminar en su totalidad ciertas funciones y
                funcionalidades. Usted acepta que TREND no tiene obligación de
                proporcionar Actualizaciones ni de continuar proporcionando o
                habilitando ninguna función o funcionalidad concreta. Según la
                configuración de su dispositivo, cuando su dispositivo esté
                conectado a Internet: (i) el software descargará e instalará
                automáticamente todas las actualizaciones disponibles, o (ii)
                puede recibir avisos o solicitar que se descarguen e instalen
                Actualizaciones disponibles. Para poder utilizar plenamente el
                software, debe descargar e instalar de inmediato todas las
                Actualizaciones. Usted reconoce que el Software o partes de este
                pueden no funcionar correctamente si no lo hace. Usted acepta
                además que todas las Actualizaciones se considerarán parte del
                Software y estarán sujetas a todos los términos y condiciones de
                este CLUF.
              </li>
            </ol>
          </li>

          <li>
            <b> ENLACES A SITIOS Y SOPORTE DE TERCEROS </b>
            <ol>
              <li>
                Puede enlazar a sitios de terceros mediante el uso del Software
                (por ejemplo, a “Team Viewer”, una plataforma de soporte de
                escritorio en remoto y una impresora de etiquetas externa). Los
                sitios de terceros no están bajo el control de TREND, e TREND no
                es responsable del contenido de sitios de terceros, ningún
                enlace contenido en sitios de terceros ni ningún cambio o
                actualización de sitios de terceros. TREND no es responsable de
                la transmisión por Internet o de cualquier otra forma de
                transmisión recibida de sitios de terceros. TREND le proporciona
                estos enlaces a sitios de terceros solo por su conveniencia, y
                la inclusión de cualquier enlace no implica un respaldo por
                parte de TREND del sitio de terceros.
              </li>
              <li>
                Si desea obtener más información sobre el Software o si tiene
                problemas para usarlo, visite{" "}
                <a
                  href="https://www.trend-networks.com/in/en/index.aspx"
                  target="_blank"
                >
                  <b>www.trend-networks.com</b>
                </a>
                para obtener información de contacto por correo electrónico y
                teléfono en su zona. TREND no tendrá que proporcionar ningún
                servicio de soporte en virtud de este CLUF. Si usted requiere
                algún soporte, este se puede proporcionar previa solicitud en
                función del tiempo y según unos costes. Este CLUF no le otorga
                ningún derecho a actualizaciones o mejoras del Software ni a
                ninguna ampliación o mejoría del Software desarrollada por o en
                nombre de TREND en cualquier momento en el futuro. TREND puede
                ofrecer servicios de soporte por separado. Cualquier código de
                software complementario o materiales relacionados que TREND le
                proporcione como parte de los servicios de soporte debe
                considerarse parte del Software y está sujeto a los términos y
                condiciones de este CLUF.
              </li>
            </ol>
          </li>

          <li>
            <b> INFORMACIÓN CONFIDENCIAL</b> <br />
            Usted reconoce y acepta que el Software (excluyendo cualquier
            Software de código abierto) y toda la información que emane del
            Software y el negocio de TREND en cualquier forma son propiedad
            intelectual valiosa de TREND y se consideran información
            confidencial de TREND (Información confidencial). Usted acepta que,
            durante o después de la vigencia de este CLUF, no permitirá la
            duplicación, uso o divulgación de dicha Información confidencial a
            ninguna persona, a menos que dicha duplicación, uso o divulgación
            esté específicamente autorizado por TREND por escrito antes de
            cualquier divulgación. Debe utilizar la diligencia debida, y en
            ningún caso por debajo del grado de cuidado que utilice con respecto
            a su propia información confidencial de naturaleza similar, para
            evitar la divulgación o reproducción no autorizadas de la
            Información confidencial. Sin limitar la generalidad de lo anterior,
            en la medida en que este CLUF permita la copia de Información
            confidencial, todas estas copias deben tener los mismos avisos de
            confidencialidad, leyendas y las designaciones de derechos de
            propiedad intelectual que aparecen en las versiones originales, y la
            parte debe mantener registros detallados de la ubicación de toda la
            Información confidencial.
          </li>

          <li>
            <b> DERECHO A RESCINDIR EL CLUF</b>
            <ol>
              <li>
                Este CLUF seguirá aplicándose hasta que usted o TREND lo
                rescinda como se indica en el presente documento.
              </li>
              <li>
                Puede rescindir este CLUF en cualquier momento dejando de
                acceder al Software o desinstalando permanentemente el Software
                de su equipo en su totalidad.
              </li>
              <li>
                Sus derechos se rescindirán de forma automática e inmediata sin
                previo aviso de TREND si no cumple con alguna disposición de
                este CLUF. En dicho caso, debe dejar de acceder inmediatamente
                al Software o desinstalar el Software.
              </li>
              <li>
                TREND puede rescindir su derecho a utilizar el Software en
                cualquier momento, con o sin previo aviso. Los términos de este
                CLUF relacionados con el uso de datos, indemnización, limitación
                de responsabilidad, confidencialidad, resolución de disputas y
                construcción y formación de acuerdo seguirán vigentes tras la
                rescisión o vencimiento de este CLUF.
              </li>
            </ol>
          </li>

          <li>
            <b> INDEMNIZACIÓN </b>
            <br />
            Hasta la máxima medida permitida por la ley, usted acepta defender,
            indemnizar y mantener indemne a TREND, sus subsidiarias y filiales y
            sus respectivos directores, funcionarios, empleados y agentes de y
            contra cualquier reclamación, acción legal, demanda o procedimiento,
            así como todas las pérdidas, responsabilidades, daños, costes y
            gastos (incluidos los honorarios de abogados razonables) que surjan
            de o que se devenguen de su uso del Software (o de cualquier persona
            que actúe con su cuenta o contraseña), incluido su acceso,
            instalación o uso del Software, o su incumplimiento de este CLUF.
          </li>

          <li>
            <b> LIMITACIÓN DE RESPONSABILIDAD</b>
            <ol>
              <li>
                TREND NO EXCLUYE NI LIMITA DE NINGUNA MANERA SU RESPONSABILIDAD
                ANTE USTED EN CASO DE QUE SEA ILEGAL HACERLO. ESTO INCLUYE LA
                RESPONSABILIDAD POR MUERTE O LESIONES PERSONALES CAUSADAS POR LA
                NEGLIGENCIA DE TREND O LA NEGLIGENCIA DE SUS EMPLEADOS, AGENTES
                O SUBCONTRATISTAS, O POR FRAUDE O TERGIVERSACIÓN FRAUDULENTA.
              </li>
              <li>
                USTED ENTIENDE Y ACEPTA EXPRESAMENTE QUE SU USO DEL SOFTWARE
                ESTÁ A SU ENTERA DISCRECIÓN Y RIESGO, Y QUE EL SOFTWARE SE
                PROPORCIONA “TAL CUAL” Y “SEGÚN DISPONIBILIDAD” SIN GARANTÍA DE
                NINGÚN TIPO, EXPRESA O IMPLÍCITA. USTED ES EL ÚNICO RESPONSABLE
                DE CUALQUIER DAÑO EN SU ORDENADOR, U OTRO DISPOSITIVO, O PÉRDIDA
                DE DATOS POR DICHO USO. TREND ADEMÁS RENUNCIA EXPRESAMENTE A
                TODAS LAS DEMÁS GARANTÍAS Y CONDICIONES DE CUALQUIER TIPO, YA
                SEAN EXPRESAS O IMPLÍCITAS, LO QUE INCLUYE, PERO NO SE LIMITA A,
                LAS GARANTÍAS Y CONDICIONES IMPLÍCITAS DE COMERCIABILIDAD,
                IDONEIDAD PARA UN FIN PARTICULAR Y NO INFRACCIÓN CON RESPECTO AL
                SOFTWARE. ALGUNAS JURISDICCIONES NO PERMITEN LA RENUNCIA O
                EXCLUSIÓN DE GARANTÍAS IMPLÍCITAS, POR LO QUE PUEDEN NO SER
                APLICABLES A USTED. TREND NO GARANTIZA LA NO INTERFERENCIA CON
                SU DISFRUTE DEL SOFTWARE, QUE LAS FUNCIONES CONTENIDAS EN O LOS
                SERVICIOS PRESTADOS O PROPORCIONADOS POR EL SOFTWARE CUMPLIRÁN
                SUS REQUISITOS, QUE EL FUNCIONAMIENTO DEL SOFTWARE O SERVICIOS
                SERÁ ININTERRUMPIDO O LIBRE DE ERRORES NI QUE SE CORREGIRÁN LOS
                DEFECTOS DEL SOFTWARE O LOS SERVICIOS. NINGUNA INFORMACIÓN O
                CONSEJO ORAL O ESCRITO PROPORCIONADO POR TREND O SUS
                REPRESENTANTES AUTORIZADOS DARÁ LUGAR A UNA GARANTÍA.
              </li>
              <li>
                USTED ENTIENDE Y ACEPTA EXPRESAMENTE QUE, EXCEPTO CON RESPECTO A
                LA SECCIÓN 10.1, TREND, SUS SUBSIDIARIAS Y FILIALES Y SUS
                LICENCIANTES NO ASUMIRÁN RESPONSABILIDAD ALGUNA ANTE USTED POR
                PÉRDIDAS O DAÑOS DE CUALQUIER NATURALEZA O IMPORTE, EN VIRTUD DE
                CUALQUIER TEORÍA DE RESPONSABILIDAD, INDEPENDIENTEMENTE DE SI
                TALES PÉRDIDAS O DAÑOS SON O NO DIRECTOS, INDIRECTOS,
                INCIDENTALES, ESPECIALES, EMERGENTES O PUNITORIOS,
                INDEPENDIENTEMENTE DE SI DICHAS PÉRDIDAS O DAÑOS SON O NO
                SUFRIDOS O INCURRIDOS POR USTED A TRAVÉS DE SU USO DEL SOFTWARE,
                INCLUIDA CUALQUIER PÉRDIDA DE DATOS O DAÑOS A SUS DISPOSITIVOS,
                E INDEPENDIENTEMENTE DE SI USTED O SUS REPRESENTANTES HAN SIDO O
                NO INFORMADOS O SI HAN TENIDO CONOCIMIENTO DE LA POSIBILIDAD DE
                QUE SE PRODUZCAN DICHAS PÉRDIDAS.
              </li>
              <li>
                HAGA COPIAS DE SEGURIDAD DEL CONTENIDO Y DE LOS DATOS UTILIZADOS
                CON EL SOFTWARE. TREND RECOMIENDA HACER COPIAS DE SEGURIDAD DE
                CUALQUIER CONTENIDO Y DATOS UTILIZADOS EN RELACIÓN CON EL
                SOFTWARE PARA PROTEGERSE EN CASO DE EXPERIMENTAR PROBLEMAS CON
                EL MISMO.
              </li>
            </ol>
          </li>

          <li>
            <b> CAMBIOS EN EL CLUF </b>
            <br />
            En cualquier momento, mediante una notificación (ya sea por correo
            electrónico, en línea, a través del Software o de otro modo) que
            especifique la enmienda, TREND puede modificar el CLUF (incluida una
            enmienda en cuanto a las tarifas pagaderas por su uso del Software)
            y se considerará que dicha enmienda entrará en vigor tras un plazo
            de treinta (30) días a contar desde la fecha de dicha notificación.
            Usted deberá reconocer y aceptar dichas enmiendas, según lo
            especificado en la notificación. La no aceptación de dichas
            enmiendas dará derecho a que TREND rescinda este CLUF previo aviso
            con un (1) mes de antelación.
          </li>

          <li>
            <b> NOTIFICACIONES </b>
            <ol>
              <li>
                Cualquier notificación u otra comunicación proporcionada a una
                parte en virtud de o en relación con este CLUF será por escrito
                y se entregará a mano o por correo postal urgente prepagado u
                otro servicio de entrega al siguiente día laborable en el
                domicilio social (si es una empresa) o en la sede principal (en
                cualquier otro caso) de dicha parte.
              </li>
              <li>
                Cualquier notificación o comunicación se considerará recibida:
                (i) si se entrega a mano, en el momento de la firma de un recibo
                de entrega o en el momento en que la notificación se deje en la
                dirección correcta; (ii) si se envía por correo postal urgente u
                otro servicio de entrega al siguiente día laborable, a las 9:00
                de la mañana del segundo día laborable tras el envío o en el
                momento registrado por el servicio de entrega, y (iii) si se
                envía por correo electrónico, en el momento de la transmisión,
                o, si esa hora estuviera fuera del horario laboral del lugar del
                destinatario, cuando se reanude el horario laboral (de 9:00 a
                17:00 h de lunes a viernes en un día que no sea festivo en el
                lugar del destinatario).
              </li>
            </ol>
          </li>

          <li>
            <b> LEGISLACIÓN APLICABLE Y JURISDICCIÓN</b>
            Este CLUF y cualquier disputa o reclamación (incluidas disputas o
            reclamaciones no contractuales) que surja de o en relación con él, o
            su objeto o formación se regirán e interpretarán de conformidad con
            la ley de Inglaterra y Gales, y cada parte de forma irrevocable
            acepta que los tribunales de Inglaterra y Gales tendrán jurisdicción
            exclusiva para resolver cualquier disputa o reclamación (incluidas
            disputas o reclamaciones no contractuales) que surja de o esté
            relacionada con este CLUF, su objeto o formación.
          </li>

          <li>
            <b>VARIOS</b>
            <br />
            Este CLUF (incluido cualquier anexo o enmienda al mismo) es el
            acuerdo completo entre usted e TREND relativo al Software y los
            servicios de soporte (si los hubiera) y sustituye todas las
            comunicaciones orales o escritas anteriores o contemporáneas,
            propuestas y declaraciones con respecto al Software o cualquier otro
            asunto contemplado en este CLUF. En la medida en que los términos de
            las políticas o términos de los servicios de soporte de TREND entren
            en conflicto con los términos de este CLUF, los términos de este
            CLUF prevalecerán. Si alguna disposición de este CLUF se considera
            nula, no válida, inaplicable o ilegal, dicha disposición se
            considerará rediseñada para reflejar la intención original de las
            partes en la máxima medida posible y de conformidad con la
            legislación aplicable, y las demás disposiciones continuarán en
            pleno vigor y efecto. El hecho de que TREND no ejerza o haga cumplir
            cualquier derecho o disposición de este CLUF no constituirá una
            renuncia a dicho derecho o disposición, a menos que sea reconocido y
            aceptado por TREND por escrito. Ni el curso de conducta entre las
            partes ni la práctica comercial podrán modificar ninguna disposición
            de este CLUF. No podrá ceder este CLUF ni ninguno de sus derechos en
            virtud de este CLUF sin el consentimiento previo por escrito de
            TREND, que puede ser otorgado o condicionado a nuestra única y
            absoluta discreción, y cualquier intento de cesión sin dicho
            consentimiento será nulo e inválido. Con sujeción a la restricción
            anterior, este CLUF será totalmente vinculante, en beneficio de y
            ejecutable por TREND y nuestros respectivos sucesores y cesionarios.
            TREND puede transferir sus derechos y obligaciones en virtud de
            estos términos a otra organización.
          </li>
        </ol>
      </span>
    </React.Fragment>
  );
};

export default TermsAndCondition;



// WEBPACK FOOTER //
// ./src/components/signup/termsAndCondition/components/spanish.js